import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  FOLLOW_UPS_REFRESH: createSagaAction('FOLLOW_UPS_REFRESH'),

  FOLLOW_UP_CREATE: createSagaAction('FOLLOW_UP_CREATE'),
  FOLLOW_UP_UPDATE: createSagaAction('FOLLOW_UP_UPDATE'),
  FOLLOW_UP_DELETE: createSagaAction('FOLLOW_UP_DELETE'),

  GET_FOLLOW_UP_ACTIVITIES: createSagaAction('GET_FOLLOW_UP_ACTIVITIES'),

  JOB_FOLLOW_UP_GET_RELATED_ENTITY: createSagaAction('JOB_FOLLOW_UP_GET_RELATED_ENTITY')
}

// Action Creators
export const actions = {
  jobFollowUpsRefresh: ({ jobId }) => ({
    type: constants.FOLLOW_UPS_REFRESH.ACTION,
    jobId
  }),

  getRelatedEntity: ({ followUpId }) => ({
    type: constants.JOB_FOLLOW_UP_GET_RELATED_ENTITY.ACTION,
    followUpId
  }),

  createFollowUp: ({ jobId, content, userId }) => ({
    type: constants.FOLLOW_UP_CREATE.ACTION,
    jobId,
    content,
    userId
  }),

  updateFollowUp: ({ jobId, followUpId, userId, content }) => ({
    type: constants.FOLLOW_UP_UPDATE.ACTION,
    jobId,
    followUpId,
    userId,
    content
  }),

  deleteFollowUp: ({ followUpId, jobId }) => ({
    type: constants.FOLLOW_UP_DELETE.ACTION,
    jobId,
    followUpId
  }),

  getFollowUpActivities: ({ followUpId }) => ({
    type: constants.GET_FOLLOW_UP_ACTIVITIES.ACTION,
    followUpId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.FOLLOW_UPS_REFRESH.SUCCESS:
      return {
        ...state,
        followUps: action.payload
      }
    case constants.FOLLOW_UP_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.FOLLOW_UP_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.FOLLOW_UP_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_FOLLOW_UP_ACTIVITIES.SUCCESS:
      return {
        ...state,
        followUpActivities: action.payload
      }
    case constants.JOB_FOLLOW_UP_GET_RELATED_ENTITY.SUCCESS:
      return {
        ...state,
        followUpRelatedEntity: action.entities
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobFollowUpActions.js